import React, { Component } from "react";
import { BASE_URL } from "./utility";

class Header extends Component {
  render() {
    return (
      <>
        <style>{`
          @media (max-width: 768px) {
            .header-container {
              display: flex !important;
              justify-content: center;
              align-items: center;
            }
          }
        `}</style>

        <div className="header-container" style={{ display: "inline-block" }}>
          <img
            height={90}
            width={200}
            src={BASE_URL + "download/general/name"}
            alt="Name"
            style={{ maxWidth: "90%", height: "auto" }}
          />
        </div>
      </>
    );
  }
}

export default Header;
